export default __webpack_public_path__ + "static/media/I0005.f0f21d64.png";